import * as R from 'ramda';
import { createConfig, getConfiguration } from "../plugin/config.model";
import { BookingStoreNamespace } from "../../modules/booking/store";
import { DistributionStoreNamespace } from "../../modules/distribution/store";
import { SET_CONTACT_FILES } from '../../modules/contacts/store/types';
import { ContactStoreNamespace } from '../../modules/contacts/store';
import { AccountingStoreNamespace } from '../../modules/accounting/store';
import { SET_COSTS_FILES } from '../../modules/accounting/store/types';
import { ARTIST_FILES, UPDATE_MANY_FILES, VENUE_FILES, UPDATE_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES } from "../../modules/booking/store/types";
import { ACCOUNT_FILES } from "../../modules/distribution/store/types";

import { pipe, prop } from 'ramda';
import { CatalogStoreNamespace } from '../../modules/catalog/store';
import { SET_CATALOG_PRODUCT_FILES, SET_TRACK_PRODUCT_FILES, SET_LABEL_PRODUCT_FILES } from '../../modules/catalog/store/types';
import { SET_RELEASE_PRODUCT_FILES } from '../../modules/catalog/store/types';
import { SET_ARTIST_PRODUCT_FILES } from '../../modules/catalog/store/types';
import { SET_LICENCE_RELEATED_FILES } from '../../modules/licensing/store/types';
import { SET_DISTRIBUTION_STATEMENT_FILES,SET_DISTRIBUTION_SUPPLIER_FILES,SET_DISTRIBUTION_ACCOUNT_FILES,SET_DISTRIBUTION_SUPPLIER_ORDER_FILES } from '../../modules/distribution/store/types';

import { RoyaltyStoreNamespace } from '../../modules/royalty/store';
import { LicenceStoreNamespace } from '../../modules/licensing/store';
import { SET_CONTRACT_PRODUCT_FILES, SET_ROYALTY_ACCOUNT_FILES } from '../../modules/royalty/store/types';
import { ContactFiles } from '../../modules/contacts/store/files/types';

export const fileConfig = createConfig({
  'calendar_dates': {
    action: `${BookingStoreNamespace}/${UPDATE_MANY_FILES}`
  },
  'artists': {
    action: `${BookingStoreNamespace}/${ARTIST_FILES.UPDATE.ALL}`
  },
  'account': {
    action: `${DistributionStoreNamespace}/${SET_DISTRIBUTION_ACCOUNT_FILES}`
  },
  'booking_locations': {
    action: `${BookingStoreNamespace}/${VENUE_FILES.UPDATE.ALL}`
  },
  'contacts': {
    action: `${ContactStoreNamespace}/${ContactFiles.SET.ALL}`,
  },
  'promoter': {
    action: `${BookingStoreNamespace}/${UPDATE_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES}`
  },
  'invoices': {
    action: `${AccountingStoreNamespace}/${SET_COSTS_FILES}`
  },
  'product': {
    action: `${CatalogStoreNamespace}/${SET_CATALOG_PRODUCT_FILES}`
  },
  'release': {
    action: `${CatalogStoreNamespace}/${SET_RELEASE_PRODUCT_FILES}`
  },
  'artist': {
    action: `${CatalogStoreNamespace}/${SET_ARTIST_PRODUCT_FILES}`
  },
  'track': {
    action: `${CatalogStoreNamespace}/${SET_TRACK_PRODUCT_FILES}`
  },
  'label': {
    action: `${CatalogStoreNamespace}/${SET_LABEL_PRODUCT_FILES}`
  },
  'contracts': {
    action: `${RoyaltyStoreNamespace}/${SET_CONTRACT_PRODUCT_FILES}`
  },
  'royalty_account': {
    action: `${RoyaltyStoreNamespace}/${SET_ROYALTY_ACCOUNT_FILES}`
  },
  'licence':{
    action:`${LicenceStoreNamespace}/${SET_LICENCE_RELEATED_FILES}`
  },
  'statement':{
    action:`${DistributionStoreNamespace}/${SET_DISTRIBUTION_STATEMENT_FILES}`
  },
  'supplier':{
    action:`${DistributionStoreNamespace}/${SET_DISTRIBUTION_SUPPLIER_FILES}`
  },
  'supplier_orders':{
    action:`${DistributionStoreNamespace}/${SET_DISTRIBUTION_SUPPLIER_ORDER_FILES}`
  }
});


export const getFileConfig = getConfiguration(fileConfig);
export const getFileAction = pipe(getConfiguration(fileConfig), prop('action'));

export const deleteFileFromArray = (fileArray, file) => {
  const { file_relation_id } = file;
  return fileArray.filter(f => {
    if (f.file_relation_id == file_relation_id) {
      return false;
    } else {
      return true;
    }
  });
}